import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

const ArrowRight = (props) => (
  <Svg
    width={16}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.886 11.83a.942.942 0 0 0 1.33 1.332l5.508-5.496a.942.942 0 0 0 0-1.332L10.215.838a.941.941 0 1 0-1.33 1.332l3.896 3.888H.972a.941.941 0 0 0 0 1.883h11.81L8.886 11.83Z"
      fill="#6C63FE"
    />
  </Svg>
)

export default ArrowRight
